import * as React from 'react';
import accounting from 'accounting';

import Select from 'src/components/common/Select2';
import env from 'src/shared/env';
import { ISelectOption } from 'src/components/common/Select2/components/SelectOption/SelectOption';

import {
  goToPartDetail,
  partDetailUrl,
  getOrgpart
} from 'src/utils/navigation';
import { isMobile } from 'src/utils/responsiveHelpers';
import defaultImage from 'src/assets/defaultImage';
import './SpecialItem.scss';
import Alert from 'src/components/common/Alert/Alert';
import { startEndWithWhiteSpacesValidation } from 'src/utils/whiteSpacesValidation';

interface ISpecialItemProps {
  id: number;
  mfc: string;
  name: string;
  image: string;
  description: string;
  price: number;
  retailPrice: number;
  total: number;
  inStock: boolean;
  deliverFrom: string;
  warehouse: string;
  warranties: ISelectOption[];
  replacementMfc: string;
  replacementPart: string;
  alternateProductNumber: string;
  alternateProductManufacturer: string;
  oemProductNumber: string;
  oemProductManufacturer: string;
  warehouseName: string;
  handleAddToCart(
    claims: string,
    delivery: string,
    deliveryLocation: string,
    oneTimeAddress: null,
    partNumber: string,
    quantity: number,
    rushOrder: boolean,
    shipmentMarking: string,
    shipsfrom: string,
    ticketNumber: string,
    warrantyProvider: string
  ): void;
  t?: any;
  onConsignmentCheck: (id: number, flag: boolean, frm: string) => void;
  warehouseCosignment: IItemsWarehouseDefault;
}

interface ISpecialItemsState {
  isMobile: boolean;
  showMarks: boolean;
  qty: number;
  shipmentMarking: string;
  warrantyProvider: string;
  dispatch: string;
  showShipmentAlert: boolean;
  showDispatchClaimsAlert: boolean;
  showQuantityAlert: boolean;
  isShowExceedError: boolean;
}
interface IItemsWarehouseDefault {
  warehouseCode: string;
  description: string;
  quantity: number;
}

class SpecialItem extends React.Component<
  ISpecialItemProps,
  ISpecialItemsState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile(),
      showMarks: false,
      qty: 1,
      shipmentMarking: '',
      warrantyProvider: null,
      dispatch: '',
      showShipmentAlert: false,
      showDispatchClaimsAlert: false,
      showQuantityAlert: false,
      isShowExceedError: false
    };
  }

  private handleShowMarks = () => {
    this.setState(prevState => ({ showMarks: !prevState.showMarks }));
  };

  private handleWarrantyChange = (sel: ISelectOption) => {
    this.setState({ warrantyProvider: sel.value });
  };


  private handleQtyChange = (e: any) => {
    this.setState({
      isShowExceedError: false
    });
    const qty = e.target.value;
    const enteredQty = Number(e.target.value);
    const availableQty = Number(this.props?.warehouseCosignment?.quantity);
    const isConsignment =
    this.props?.warehouseCosignment?.description?.includes(
      "Consignment warehouse"
    );
    if (isConsignment && enteredQty > availableQty) {
      this.setState({
        isShowExceedError: true,
        qty: 1, 
      });
      return;
    }else{
        if (Number(qty) < 1) {
          this.setState({ qty, showQuantityAlert: true });
        } else {
          this.setState({ qty, showQuantityAlert: false });
        }
       
    } 
  };

  private handleShipmentMarkingChange = (e: any) => {
    const shipmentMarking = e.target.value;

    if (
      !shipmentMarking ||
      (shipmentMarking !== ' ' &&
        !startEndWithWhiteSpacesValidation(shipmentMarking))
    ) {
      if (shipmentMarking.length === 30) {
        this.setState({
          showShipmentAlert: true,
          shipmentMarking
        });
      } else {
        this.setState({
          showShipmentAlert: false,
          shipmentMarking
        });
      }
    }
  };

  private handleDispatchChange = (e: any) => {
    const claims = e.target.value;

    if (
      !claims ||
      (claims !== ' ' && !startEndWithWhiteSpacesValidation(claims))
    ) {
      if (claims.length >= 15) {
        this.setState({
          showDispatchClaimsAlert: true,
          dispatch: claims
        });
      } else {
        this.setState({
          showDispatchClaimsAlert: false,
          dispatch: claims
        });
      }
    }
  };

  private addToCart = () => {
    this.props.handleAddToCart(
      this.state.dispatch,
      null,
      null, // this.props.deliverFrom,
      null,
      `${this.props.mfc}  ${this.props.name}`,
      this.state.qty,
      false,
      this.state.shipmentMarking,
      'closest', // this.props.warehouse,
      '', // ticket number
      this.state.warrantyProvider
    );
  };

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  public componentDidMount() {
    this.sendConsignmentFlag();
 }

 public componentDidUpdate(prevProps: any) {
  if (
    prevProps.inStock !== this.props.inStock ||
    prevProps.warehouseName !== this.props.warehouseName
  ) {
    this.sendConsignmentFlag();
  }
}

public sendConsignmentFlag = () => {
  const flag =
     this.props?.warehouseName?.includes("Consignment warehouse") &&
     !this.props.inStock;

  this.props.onConsignmentCheck(this.props.id, flag, 'PURCHASE');
};

  private renderWarrantyProviders = () => {
    const selectedProvider = this.props.warranties.find(
      wp => wp.value === this.state.warrantyProvider
    );
    const { t } = this.props;
    return (
      <Select
        options={[{ name: 'None', value: null }, ...this.props.warranties]}
        selected={selectedProvider}
        placeholder={'None'}
        label={`${t('common.addwarrantyProvider')}:`}
        onSelect={this.handleWarrantyChange}
      />
    );
  };

  private renderMarksArea = () => {
    const { t } = this.props;
    return (
      <React.Fragment>
        <div className="rp-list-special-item--marks-inputs rp-list-special-item--marks-qty">
          <label>{t('myFavourites.qty')}:</label>
          <input
            name="qty"
            type="number"
            min={1}
            value={this.state.qty}
            onChange={this.handleQtyChange}
          />
        </div>
        <div className="rp-list-special-item--marks-inputs rp-list-special-item--marks-shipment">
          <label className={this.state.warrantyProvider ? 'disabled' : ''}>
            {t('myFavourites.shipmentMarking')}:
          </label>
          <input
            name="shipmentMarking"
            type="text"
            className={this.state.warrantyProvider ? 'disabled' : ''}
            defaultValue={this.state.shipmentMarking}
            onChange={this.handleShipmentMarkingChange}
            disabled={this.state.warrantyProvider ? true : false}
            maxLength={30}
          />
        </div>
        {this.props.warranties.length > 0 && (
          <React.Fragment>
            <div className="rp-list-special-item--marks-inputs rp-list-special-item--marks-warranty">
              {this.renderWarrantyProviders()}
            </div>
            <div className="rp-list-special-item--marks-inputs rp-list-special-item--marks-claims">
              {this.state.warrantyProvider && (
                <React.Fragment>
                  <label>Dispatch/Claims:</label>
                  <input
                    name="claims"
                    type="text"
                    defaultValue={this.state.dispatch}
                    onChange={this.handleDispatchChange}
                    maxLength={15}
                  />
                </React.Fragment>
              )}
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  public renderMobile() {
    const { t } = this.props;
    return (
      <React.Fragment>
        {this.state.showShipmentAlert && (
          <Alert
            styleClass="rp-special-item-alert"
            message={
              // 'Maximum allowable length for Shipment marking is 30 characters'
              `${t('productFieldErrors.maxShipmentCharacterErr', {
                count: 30
              })}`
            }
            icon={'rpds-warning'}
            handleCloseAlert={() => {
              this.setState({
                showShipmentAlert: false
              });
            }}
            type={'warning'}
          />
        )}
        {this.state.showDispatchClaimsAlert && (
          <Alert
            styleClass="rp-special-item-alert"
            message={
              // 'Maximum allowable length for Dispatch/Claims marking is 15 characters'
              `${t('productFieldErrors.maxDispatchClaimsMarkingErr', {
                count: 15
              })}`
            }
            icon={'rpds-warning'}
            handleCloseAlert={() => {
              this.setState({
                showDispatchClaimsAlert: false
              });
            }}
            type={'warning'}
          />
        )}
        {this.state.showQuantityAlert && (
          <Alert
            styleClass="rp-special-item-alert"
            message={'Quantity must be greater than zero'}
            icon={'rpds-error'}
            handleCloseAlert={() => {
              this.setState({
                showQuantityAlert: false
              });
            }}
            type={'error'}
          />
        )}

        {this.state.isShowExceedError && (
            <Alert
              styleClass="rp-special-item-alert"
              message={`We are no longer accepting backorders for consignment warehouse. Available qty is ${this.props?.warehouseCosignment?.quantity}`}
              icon="rpds-error"
              type="error"
              handleCloseAlert={() =>
                this.setState({ isShowExceedError: false })
              }
            />
        )}
        <div className="rp-list-special-item">
          <div className="rp-list-special-item-top">
            <div className="rp-list-special-item--image-area">
              <div
                className="image-container"
                style={{
                  backgroundImage: `url(${
                    this.props.image !== '' ? this.props.image : defaultImage
                  })`
                }}
              />
            </div>
            <div className="rp-list-special-item--info-area">
              <div>
                <div className="rp-list-special-item--name-area">
                  <a
                    style={{ cursor: 'pointer' }}
                    className="rp-list-special-item--name-area-link"
                    href={partDetailUrl(
                      `${this.props.mfc}  ${this.props.name}`
                    )}
                    onClick={e =>
                      goToPartDetail(`${this.props.mfc}  ${this.props.name}`)
                    }
                  >
                    {`${this.props.mfc} ${this.props.name}`}
                  </a>
                </div>
                <div className="rp-list-special-item--description-area">
                  {this.props.description}
                </div>
              </div>
              <div className="rp-list-special-item--stock-area">
                <span
                  className={
                    this.props.inStock
                      ? `rpds-check-circle stock-success-icon`
                      : `rpds-error stock-error-icon`
                  }
                />
                {this.props.inStock
                  ? `${t('common.inStock')}`
                  : `${t('common.outOfStock')}`}
              </div>
              <div className="rp-list-special-item--prices-area">
                <div className="rp-list-special-item--prices-single">
                  <label>MSRP </label>
                  {this.props.retailPrice
                    ? accounting.formatMoney(this.props.retailPrice)
                    : 'NA'}
                </div>
                <div className="rp-list-special-item--prices-single">
                  <label>{t('myFavourites.yourPrice')} </label>
                  {this.props.price
                    ? accounting.formatMoney(this.props.price)
                    : 'NA'}
                </div>
                <div className="rp-list-special-item--prices-single">
                  <label>{t('myFavourites.itemTotal')}</label>
                  {this.props.total
                    ? accounting.formatMoney(this.props.total * this.state.qty)
                    : 'NA'}
                </div>
              </div>
            </div>
          </div>
          <div className="rp-list-special-item--marks-area">
            {this.state.isMobile ? (
              <React.Fragment>
                <div
                  className="rp-list-special-item--marks-expandable"
                  onClick={this.handleShowMarks}
                >
                  {t('cartPage.orderDetails')}{' '}
                  <span
                    className={`${
                      this.state.showMarks ? 'rpds-remove' : 'rpds-add'
                    }`}
                  />
                </div>
                {this.state.showMarks && this.renderMarksArea()}
              </React.Fragment>
            ) : (
              this.renderMarksArea()
            )}
          </div>
          <div className="rp-list-special-item--buttons-area">
          { this.props?.warehouseName?.includes("Consignment warehouse") && !this.props.inStock ?
            (
              ''
            ):(
            <button className="primary-button" onClick={this.addToCart}>
              <span className="rpds-shopping-cart" />
              {t('myFavourites.addToCart')}
            </button>
            )}
           

            {this.props.alternateProductNumber &&
            !this.props.oemProductNumber ? (
              <div>
                <button
                  className="viewbutton"
                  type="button"
                  // href={partDetailUrl(
                  //   `${this.props.alternateProductManufacturer}  ${this.props.alternateProductNumber}`
                  // )}
                  onClick={e => {
                    goToPartDetail(
                      `${this.props.alternateProductManufacturer}  ${this.props.alternateProductNumber}`
                    );
                  }}
                >
                  {t('myFavourites.viewnonoem')}
                </button>
              </div>
            ) : (
              ''
            )}
            {this.props.oemProductNumber &&
            !this.props.alternateProductNumber ? (
              <div>
                <button
                  className="viewbutton"
                  type="button"
                  // href={partDetailUrl(
                  //   `${this.props.oemProductManufacturer}  ${this.props.oemProductNumber}`
                  // )}
                  onClick={e => {
                    goToPartDetail(
                      `${this.props.oemProductManufacturer}  ${this.props.oemProductNumber}`
                    );
                  }}
                >
                  {t('myFavourites.viewoem')}
                </button>
              </div>
            ) : (
              ''
            )}
            {this.props.replacementMfc && this.props.replacementPart ? (
              <button
                className="subavailable"
                onClick={e => {
                  goToPartDetail(
                    `${this.props.replacementMfc}  ${this.props.replacementPart}`
                  );
                }}
              >
                {t('myFavourites.subavailable')}
              </button>
            ) : (
              ''
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }

  public renderDesktop() {
    const { t } = this.props;
    return (
      <React.Fragment>
        {this.state.showShipmentAlert && (
          <Alert
            styleClass="rp-special-item-alert-warning"
            message={
              // 'Maximum allowable length for Shipment marking is 30 characters'
              `${t('productFieldErrors.maxShipmentCharacterErr', {
                count: 30
              })}`
            }
            icon={'rpds-error'}
            handleCloseAlert={() => {
              this.setState({
                showShipmentAlert: false
              });
            }}
            type={'error'}
          />
        )}
        {this.state.showDispatchClaimsAlert && (
          <Alert
            styleClass="rp-special-item-alert-warning"
            message={
              // 'Maximum allowable length for Dispatch/Claims marking is 15 characters'
              `${t('productFieldErrors.maxDispatchClaimsMarkingErr', {
                count: 15
              })}`
            }
            icon={'rpds-error'}
            handleCloseAlert={() => {
              this.setState({
                showDispatchClaimsAlert: false
              });
            }}
            type={'error'}
          />
        )}
        {this.state.showQuantityAlert && (
          <Alert
            styleClass="rp-special-item-alert"
            message={'Quantity must be greater than zero'}
            icon={'rpds-error'}
            handleCloseAlert={() => {
              this.setState({
                showQuantityAlert: false
              });
            }}
            type={'error'}
          />
        )}
        {this.state.isShowExceedError && (
            <Alert
              styleClass="rp-special-item-alert"
              message={`We are no longer accepting backorders for consignment warehouse. Available qty is ${this.props?.warehouseCosignment?.quantity}`}
              icon="rpds-error"
              type="error"
              handleCloseAlert={() =>
                this.setState({ isShowExceedError: false })
              }
            />
        )}
        <div className="rp-list-special-item">
          <div className="rp-list-special-item--image-area">
            <div
              className="image-container"
              style={{
                backgroundImage: `url(${
                  this.props.image !== '' ? this.props.image : defaultImage
                })`
              }}
            />
          </div>
          <div className="rp-list-special-item--main-info">
            <div>
              <div className="rp-list-special-item--name-area">
                <a
                  className="rp-list-special-item--name-area-link"
                  href={partDetailUrl(`${this.props.mfc}  ${this.props.name}`)}
                  style={{ cursor: 'pointer' }}
                  onClick={e =>
                    goToPartDetail(`${this.props.mfc}  ${this.props.name}`)
                  }
                >
                  {`${this.props.mfc} ${this.props.name}`}
                </a>
              </div>
              <div className="rp-list-special-item--description-area">
                {this.props.description}
              </div>
            </div>
            <div className="rp-list-special-item--prices-area">
              <div className="rp-list-special-item--prices-single">
                <label>MSRP </label>
                {this.props.retailPrice
                  ? accounting.formatMoney(this.props.retailPrice)
                  : 'NA'}
              </div>
              <div className="rp-list-special-item--prices-single">
                <label>{t('myFavourites.yourPrice')} </label>
                {this.props.price
                  ? accounting.formatMoney(this.props.price)
                  : 'NA'}
              </div>
              <div className="rp-list-special-item--prices-single">
                <label>{t('myFavourites.itemTotal')}</label>
                {this.props.total
                  ? accounting.formatMoney(this.props.total * this.state.qty)
                  : 'NA'}
              </div>
            </div>
          </div>
          <div className="rp-list-special-item--optional-info">
            <div className="rp-list-special-item--stock-area">
              <span
                className={
                  this.props.inStock
                    ? `rpds-check-circle stock-success-icon`
                    : `rpds-error stock-error-icon`
                }
              />
              {this.props.inStock
                ? `${t('common.inStock')}`
                : `${t('common.outOfStock')}`}
            </div>
            <div className="rp-list-special-item--marks-area">
              {this.state.isMobile ? (
                <React.Fragment>
                  <div
                    className="rp-list-special-item--marks-expandable"
                    onClick={this.handleShowMarks}
                  >
                    {t('cartPage.orderDetails')}{' '}
                    <span
                      className={`${
                        this.state.showMarks ? 'rpds-remove' : 'rpds-add'
                      }`}
                    />
                  </div>
                  {this.state.showMarks && this.renderMarksArea()}
                </React.Fragment>
              ) : (
                this.renderMarksArea()
              )}
            </div>
          </div>
          <div className="rp-list-special-item--buttons-area">
            { this.props?.warehouseName?.includes("Consignment warehouse") && !this.props.inStock ?
            (
              ''
            ):(
            <button className="primary-button" onClick={this.addToCart}>
              <span className="rpds-shopping-cart" />
              {t('myFavourites.addToCart')}
            </button>
            )}

            {this.props.alternateProductNumber &&
            !this.props.oemProductNumber ? (
              <div>
                <button
                  className="viewbutton"
                  type="button"
                  // href={partDetailUrl(
                  //   `${this.props.alternateProductManufacturer}  ${this.props.alternateProductNumber}`
                  // )}
                  onClick={e => {
                    goToPartDetail(
                      `${this.props.alternateProductManufacturer}  ${this.props.alternateProductNumber}`
                    );
                  }}
                >
                  {t('myFavourites.viewnonoem')}
                </button>
              </div>
            ) : (
              ''
            )}
            {this.props.oemProductNumber &&
            !this.props.alternateProductNumber ? (
              <div>
                <button
                  className="viewbutton"
                  type="button"
                  // href={partDetailUrl(
                  //   `${this.props.oemProductManufacturer}  ${this.props.oemProductNumber}`
                  // )}
                  onClick={e => {
                    goToPartDetail(
                      `${this.props.oemProductManufacturer}  ${this.props.oemProductNumber}`
                    );
                  }}
                >
                  {t('myFavourites.viewoem')}
                </button>
              </div>
            ) : (
              ''
            )}
            {this.props.replacementMfc && this.props.replacementPart ? (
              <button
                className="subavailable"
                onClick={e => {
                  goToPartDetail(
                    `${this.props.replacementMfc}  ${this.props.replacementPart}`
                  );
                }}
              >
                {t('myFavourites.subavailable')}
              </button>
            ) : (
              ''
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }

  public render() {
    return this.state.isMobile ? this.renderMobile() : this.renderDesktop();
  }
}

export default SpecialItem;
